<app-preguntas-frecuentes
  [mostrarIconoEditar]="true"></app-preguntas-frecuentes>
